import { connect } from 'react-redux';

import { RootState } from 'state/reducers';
import { selectCountryCodes } from 'state/countryCodes';
import { selectCurrentUser } from 'state/signUpSteps';

import AccountDetails from './AccountDetails';

const mapStateToProps = (state: RootState) => ({
  countryCodes: selectCountryCodes(state),
  currentUser: selectCurrentUser(state),
});

export default connect(mapStateToProps)(AccountDetails);
